import React, { Component, PropTypes } from 'react';
import { Deck } from 'spectacle-ppa';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile from './index.md';

import teamCreation from './sections/01_teamCreation/teamCreationSection';
import start from './sections/02_start/startSection';
import song from './sections/03_song/songSection';
import overview from './sections/04_overview/overviewSection';
import teamIntro from './sections/05_teamIntro/teamIntroSection';
import superheroCalmingBreath from './sections/06_superheroCalmingBreath/superheroCalmingBreathSection';
import gameShow from './sections/30_gameShow/gameShowSection';
import classActivity from './sections/40_classActivity/classActivitySection';
import missionAssignment from
  './sections/70_missionAssignment/missionAssignmentSection';
import finish from './sections/90_finish/finishSection';

const md = new MarkdownScript(markdownFile);
const level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
const title = md.getSectionMetadata(`Level ${level}`, 'Title');

export default class extends Component {

  static contextTypes = {
    regionData: PropTypes.object.isRequired
  };

  static metadata = {
    title
  };

  render () {
    const {regionData} = this.context;

    return (
      <Deck transition={['slide']}
            transitionDuration={800}
            progress="bar">

        {/* Team Creation */}
        {teamCreation({ regionData })}

        {/* Start */}
        {start({ regionData })}

        {/* Theme Song */}
        {song({ level, regionData })}

        {/* Overview */}
        {overview({ regionData })}

        {/* Team Introduction */}
        {teamIntro({ regionData })}

        {/* Superhero calming breath */}
        {superheroCalmingBreath({ regionData })}

        {/* Game Show */}
        {gameShow({ level, regionData })}

        {/* Emergency kit brainstorm */}
        {classActivity({ level, subActivity: 'a', regionData })}

        {/* Make a plan popcorn */}
        {classActivity({ level, subActivity: 'b', regionData })}

        {/* Mission Assignment */}
        {missionAssignment({ level, title, regionData })}

        {/* Finish */}
        {finish({ level, regionData })}

      </Deck>
    );
  }

}



// WEBPACK FOOTER //
// ./programs/epsHybridAssembly/level1.jsx